export function getInitials(name, fallbackEmail) {
  const source = (name || '').trim();
  if (source) {
    return source
      .split(' ')
      .filter(Boolean)
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
  if (fallbackEmail) return fallbackEmail[0].toUpperCase();
  return 'U';
}
